<template>
  <div
    class="gradient-mask-r-90 flex grow gap-16 overflow-auto py-20 pl-16 pr-32 scrollbar-none"
  >
    <RevLink
      v-for="{ label, url } in links"
      :key="url"
      class="text-action-default-low body-2 shrink-0"
      :to="url"
      :underlined="false"
      >{{ label }}</RevLink
    >
  </div>
</template>

<script setup lang="ts">
import { RevLink } from '@ds/components/Link'

defineProps<{
  links: {
    label: string
    url: string
  }[]
}>()
</script>
